import React, {useState} from 'react'

import {Input, Button, Upload} from "antd";
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';

import './styles/season-serie.scss'

interface Props {
    isShowControl?: boolean,
    remove?: (index:number) => void,
    index?: number
}

function SeasonSerie({isShowControl, remove, index}: Props) {
    const [name, setName] = useState('')

    const uploadProps: UploadProps = {
        name: 'file',
        action: null,
        onChange(info) {
            console.log('onChange upload', info)
        },
    }

    const onRemove = () => {
        if (remove) {
            remove(index)
        }
    }

    return (
        <div className={"season-serie"}>
            <div className="form-group">
                <label className="form-group__label">Название *</label>
                <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Название"
                />
            </div>

            <div>
                <Upload {...uploadProps}>
                    <Button className={"app-btn-uploader"} icon={<UploadOutlined />}>Добавить озвучку</Button>
                </Upload>
            </div>

            {
                isShowControl && <div className={"season-serie__control"}>
                    <button className={"app-btn delete"} onClick={onRemove}>
                        удалить
                    </button>
                </div>
            }
        </div>
    )
}

export default SeasonSerie